import { MaintenanceAlert } from "components/common";
import { LinkSection } from "components/pages/frontpage";

const MainPage = () => {
  return (
    <div className="tw-mt-xxl">
      <MaintenanceAlert className="mb-3" />
      <LinkSection />
    </div>
  );
};

export default MainPage;
